<template>
    <footer class="bg-background text-gold p-4">
        <div class="container mx-auto text-center">
            <p>&copy; {{ currentYear }} Qui est le plus riche ?</p>
            <nav class="mt-2 space-x-4">
                <router-link to="/mentions-legales" class="hover:text-gold">Mentions légales</router-link>
                <router-link to="/politique-confidentialite" class="hover:text-gold">Politique de confidentialité</router-link>
                <router-link to="/cgu" class="hover:text-gold">CGU</router-link>
                <router-link to="/cgv" class="hover:text-gold">CGV</router-link>
            </nav>
        </div>
    </footer>
</template>
<script setup>
const currentYear = new Date().getFullYear();
</script>
